<template>
    <div class="table w-full">
        <div class="table-cell w-3o8 pr-2">
            <m-text class="inline-block" v-model="reg1" type="number" placeholder="yyyy" @input="change"
                    @enter="submit"></m-text>
        </div>
        <div class="table-cell w-1o2 pr-2">
            <m-text class="inline-block" v-model="reg2" type="number" placeholder="123456" @input="change"
                    @enter="submit"></m-text>
        </div>
        <div class="table-cell w-1o8">
            <m-text class="inline-block" v-model="reg3" type="number" placeholder="12" @input="change"
                    @enter="submit"></m-text>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Object
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                if (!v) {
                    this.reg1 = null
                    this.reg2 = null
                    this.reg3 = null
                    return
                }
                this.reg1 = v.reg1
                this.reg2 = v.reg2
                this.reg3 = v.reg3
            }
        }
    },
    data: () => ({
        reg1: null,
        reg2: null,
        reg3: null
    }),
    methods: {
        change() {
            this.$emit('input', {
                reg1: this.reg1,
                reg2: this.reg2,
                reg3: this.reg3,
                number: this.number
            })
        },
        submit() {
            this.$emit('submit')
        }
    },
    computed: {
        number() {
            return (this.reg1 || '') + (this.reg2 || '') + (this.reg3 || '')
        }
    }
}
</script>
